import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { AutocompleteControlComponent } from './autocomplete-control/autocomplete-control.component';
import { AutocompleteFormControlComponent } from './autocomplete-form-control.component';



@NgModule({
  declarations: [
    AutocompleteFormControlComponent,
    AutocompleteControlComponent
  ],
  exports: [
    AutocompleteFormControlComponent
  ],
  imports: [
    CommonModule,

    FormsModule,

    MatFormFieldModule,
    MatInputModule,
    FormControlsUtilsModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
  ]
})
export class AutocompleteFormControlModule { }
